import client from "@/services/rest/client"
import { useCasinoLobbyStore } from "../store/casinoLobby.store"

export function fetchCategories() {
  const method = "get"
  const url = "/public/categories"

  return client({ method, url })
}

export function fetchGame(slug) {
  const method = "get"
  const url = `/public/games/${slug}`

  return client({ method, url })
};

export function fetchCategory(params) {
  const method = "get"
  const url = `/public/categories/${params.slug}?with-games=${params.withGames}`

  return client({ method, url })
};

export function fetchGames(params) {
  const method = "get"
  const url = "/public/games"

  return client({ method, url, params })
};

export function fetchProviders(params) {
  const method = "get"
  const url = "/public/providers"

  return client({ method, url, params })
};

export function fetchProvider(slug) {
  const method = "get"
  const url = `/public/providers/${slug}`

  return client({ method, url })
};

export function casinoGameInit(data) {
  const method = "post"
  const url = "/modules/slotegrator/games/init"

  return client({ method, url, data })
}

export async function fetchCasinoLobby(params) {
  const method = "get"
  const url = "/public/lobby"

  const store = useCasinoLobbyStore()

  const response = await client({ method, url, params })
  store.setListCasinoLobby(response.data)

  return response
};

export function fetchExchangeRates() {
  const method = "get"
  const url = `/public/exchange-rates`

  return client({ method, url })
};
